/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { AdminService } from '../../services/admin.service';
import { GlobalMessageService } from '../../services/global-message.service';

@Component({
  selector: 'app-admin-cleanup',
  templateUrl: './admin-cleanup.component.html'
})
export class AdminCleanupComponent implements OnInit {

  loadingPage: boolean = false;
  currentTab: string = 'email';
  lookupEmail: string;
  contactData: any = {};
  showNull: boolean = false;

  fix: any = {
    emailAddress:'',
    firstName: '',
    lastName: ''
  };

  bingSearch: string = '';
  bingSearchResults: any[] = [];

  constructor(private adminService: AdminService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
  }

  search() {
    this.loadingPage = true;
    this.adminService.getContactCleanupData(this.lookupEmail).subscribe(
      (result: any) => {
        this.contactData = result;
        this.showNull = true;
        if (this.contactData.ac && this.contactData.ac.length > 0) {
          this.fix = {
            emailAddress: this.lookupEmail,
            firstName: this.contactData.ac[0].first_name,
            lastName: this.contactData.ac[0].last_name
          }
        }
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }

  updateContact() {
    this.adminService.cleanContact(this.lookupEmail, { fix: this.fix, eq: this.contactData.eq }).subscribe(
      (result: any) => {
        this.globalMessageService.message('Contact was updated');
        this.lookupEmail = this.fix.emailAddress;
        this.fix = {
          emailAddress:'',
          firstName: '',
          lastName: ''
        }
        this.search();
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }

  searchBing() {
    this.adminService.bingSearch(this.bingSearch).subscribe(
      (result: any) => {
        this.bingSearchResults = result;
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-cleanup/admin-cleanup.component.ts